import { render, staticRenderFns } from "./FormularioSubModuloComponent.vue?vue&type=template&id=4524bfc8"
import script from "./FormularioSubModuloComponent.vue?vue&type=script&lang=js"
export * from "./FormularioSubModuloComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports